export var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
export var canUseWeakSet = typeof WeakSet === 'function';
//# sourceMappingURL=canUse.js.map